import { headerInterceptorFactory } from "@faire/web/common/requests/request-interceptors/headerInterceptor";

const HEADER_CLIENT_SEND_TIME = "X-CLIENT-SEND-TIME";

/**
 * Interceptor that adds the client send time as a header to outgoing requests.
 * This helps with tracking request timing and delay analysis.
 */
export const clientSendTimeInterceptor = headerInterceptorFactory({
  header: HEADER_CLIENT_SEND_TIME,
  value: () => Date.now().toString(),
});
